module.exports = __webpack_public_path__ + "img/caja_registros.8ee7ef96.png";